import {assign} from "lodash";

export default class UrlService {

  constructor(StorageService) {
    'ngInject';
    this.StorageService = StorageService;
  }

  generate(route, params) {
    let paramString = $.param(params);
    if (paramString) {
      paramString = '?' + paramString;
    }
    return route + paramString;
  }

  generateWithJWT(route, params) {
    params = assign({
      JWT: this.StorageService.get('idToken'),  // TODO: use SessionsService.
    }, params);
    return this.generate(route, params);
  }
}
